import React, { useEffect } from 'react'
import _ from 'lodash'
import LtsMultiselectProduto from '../../components/lottus/lts-multiselect-produto'

const getFnParam = ({ record, componentInfo }) => {
  const values = record['oid_unidade'] //TODO criar config de dependencia na config 'componentInfo'
  if (_.isEmpty(values)) {
    return []
  }
  return values.map((v) => v.id)
}

export default function FormBuildMultiselectProduto(props) {
  // useEffect(() => {
  //   console.log(`FormBuildMultiselectProduto: ${JSON.stringify(props)}`)
  // }, [1])

  return (
    <div className="p-grid form-group">
      <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
        <LtsMultiselectProduto
          name={_.get(props.componentInfo, 'campo', '_undef_')}
          label={props.label}
          value={props.record[_.get(props.componentInfo, 'campo', '_undef_')]}
          onChange={(e) => props.onChange(_.get(props.componentInfo, 'campo', null), _.get(e, 'target.value', null))}
          loadDataFnParam={getFnParam({ record: props.record, componentInfo: props.componentInfo })}
        />
      </div>
    </div>
  )
}
// export const formBuildMultiselectProduto = ({ componentInfo, messages, record, onChange, label }) => {
//
//   return (
//     <div className="p-grid form-group">
//       <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
//         <LtsMultiselectProduto
//           name={_.get(componentInfo, 'campo', '_undef_')}
//           label={label}
//           value={record[_.get(componentInfo, 'campo', '_undef_')]}
//           onChange={(e) => onChange(_.get(componentInfo, 'campo', null), _.get(e, 'target.value', null))}
//           loadDataFnParam={getFnParam({ record, componentInfo })}
//         />
//       </div>
//     </div>
//   )
// }
